import { IRoleDto } from "./user";

export interface IRouteData {
    title?: string;
    allowedRoles?: RoleNames[];
    menu: 'admin' | 'tenant' | 'member' | 'government_relations';
}

export class Role {

    get id() {
        return this.roleList.id;
    }

    get objectId() {
        return this.roleList.objectId;
    }
    get name() {
        return this.roleList.value;
    }

    get display() {
        return this.roleList.displayName;
    }

    get description() {
        return this.roleList.description;
    }

    get isEnabled() {
        return this.roleList.isEnabled;
    }

    get isAdmin() {
        return this.name.toUpperCase() === 'ADMIN';
    }

    get isSupervisor() {
        return this.inRole('ADVOCATEMANAGER', 'SCREENERMANAGER');
    }

    constructor(private roleList: IRoleDto) {

    }

    inRole(...args: string[]) {
        return this.internalInRole(args);
    }

    inRoles(args: string[]) {
        return this.internalInRole(args);
    }

    private internalInRole(args: string[]) {
        const array = args as string[];
        return this.isAdmin || args.some(roleItem => roleItem.toUpperCase() === this.name.toUpperCase());
    }
}

export class RoleList {
    static Administrator: RoleNames = 'Admin';
    static Screener: RoleNames = 'Screener';
    static ScreenerManager: RoleNames = 'ScreenerManager';
    static Advocate: RoleNames = 'Advocate';
    static AdvocateManager: RoleNames = 'AdvocateManager';
    static Member: RoleNames = 'Member';
    static Tester: RoleNames = 'Tester';
    static QualityAssurance: RoleNames = 'QualityAssurance';
    static MedicalRecordReviewer: RoleNames = 'MedicalRecordReviewer';
    static TemplateManager: RoleNames = 'TemplateManager';
    static ConfigurationManager: RoleNames = 'ConfigurationManager';
}

export type RoleNames = 'Admin' | 'Screener' | 'ScreenerManager' | 'Advocate' | 'AdvocateManager' | 'Member' | 'QualityAssurance' | 'Tester' | 'MedicalRecordReviewer' | 'TemplateManager' | 'ConfigurationManager' | string;
